import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ContactIdMappingsApi from '../generated/api/ContactIdMappings';

export default (service: Servicelayer) => ({
  ...ContactIdMappingsApi(service),

  // Add custom calls here

});
